<template lang="pug">
  include /mixins
  map-of-elevators
</template>

<script>

export default ({
  data() {
    return {}
  },
})
</script>
